<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Últimos Encontros' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <div class="gradient-extendido-div">
    <div class="div-top">
      <ion-icon slot="start" name="arrow-undo" class="div-icon"></ion-icon>

      <ion-label class="color-title"> {{'Últimos Encontros' | translate}} </ion-label>
    </div>
  </div>

  <ion-card *ngFor="let d of encontros">
    <ion-grid class="ion-padding">
      <ion-row style="border-bottom: solid 1px #d1d1d1">
        <ion-col size="1">
          <i class="fa-solid fa-reply"></i>
        </ion-col>
        <ion-col size="auto">
          <ion-label>
              <p>
                <span> {{ (d.data !== null) ? (d.data | dateFormat:"mediaHora") : '---'}} </span>
              </p>
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row class="ion-padding-top">
        <ion-col>
          <h3>{{d.descricao}}</h3>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
  <div [hidden]="encontros.length">
   <sem-registro [text]="'Nenhum encontro localizado'"></sem-registro>
  </div>
</ion-content>
